import React from "react";
import { Link } from "react-router-dom";

const svc = [
  { num:"01", title:"Strategic Business Review", tag:"For principals & GMs",
    desc:"A full diagnostic of your agency's people, structure and performance. We spend time inside your business — with your leaders, your team and your data — and give you a clear, honest read on where you actually are.",
    bullets:["On-site immersion — leaders, team, systems","Structure, roles and accountability review","Retention and performance risk analysis","Written report with prioritised actions","90-day implementation roadmap"] },
  { num:"02", title:"Recruitment", tag:"Every role. Every level.",
    desc:"Proactive, headhunted, culture-fit recruitment across every real estate role — from Property Manager to General Manager. We don't run job ads and wait. We approach the people you actually want.",
    bullets:["Discovery briefing and role profiling","Active headhunting from our network","Shortlist of 3–5 pre-qualified candidates","Reference checking and offer support","30/60/90 day onboarding check-ins","90-day replacement guarantee"] },
  { num:"03", title:"Remuneration Benchmarking", tag:"Know what you should pay",
    desc:"Independent salary, commission and bonus data across every real estate role in Victoria. Know exactly what the market is paying — and what your competitors are offering to attract your best people.",
    bullets:["Role-by-role salary bandwidths","Commission and incentive structures","Retention pay recommendations","Competitor snapshot (anonymised)","Presented and explained in person"] },
  { num:"04", title:"Culture & Growth", tag:"Build the culture people stay for",
    desc:"The invisible architecture of a high-performing agency — values, rituals, communication, leadership. We help you design a culture that isn't a poster on the wall, but the way you actually run.",
    bullets:["Values definition and articulation","Leadership rhythm and team rituals","Internal comms and meeting design","Career pathways and progression","Ongoing quarterly cadence"] },
  { num:"05", title:"People & Culture Diagnostic", tag:"Hear what your team won't tell you",
    desc:"A structured deep dive into your people — engagement, retention risk, capability gaps and the honest feedback that never quite makes it to the principal's desk.",
    bullets:["Confidential 1:1 team interviews","Engagement and retention risk scoring","Capability and gap analysis","Themes and root cause report","Direct, unfiltered recommendations"] },
  { num:"06", title:"Workshops", tag:"Practical. In the room.",
    desc:"Half or full-day sessions for leadership teams and principals. Delivered by someone who has run the business — not written a book about it. Every workshop is tailored to what your team actually needs.",
    bullets:["Hiring right — an interviewing masterclass","Difficult conversations for leaders","Building a retention-first culture","Feedback and performance rhythm","Custom topics on request"] }
];

const Services = () => {
  return (
    <>
      <div className="page-hero">
        <span className="page-hero-eyebrow">Services</span>
        <h1>Six ways we<br />help you build<br /><em>a better agency.</em></h1>
        <p>From a one-off diagnostic to a long-term partnership — every service is delivered personally by Laura, and every engagement is designed around what your agency actually needs. No packages. No add-ons. No filler.</p>
      </div>

      <section className="section section-black">
        {svc.map((s,i) => (
          <div key={s.num} style={{padding:'3rem 0',borderBottom: i===svc.length-1 ? 'none' : '1px solid var(--border)'}}>
            <div className="two-col" style={{alignItems:'start'}}>
              <div>
                <span className="eyebrow">{s.tag}</span>
                <div style={{display:'flex',alignItems:'baseline',gap:'1.25rem',marginBottom:'1.5rem'}}>
                  <span style={{fontSize:'1.3rem',fontWeight:800,color:'var(--gold)'}}>{s.num}</span>
                  <h2 className="h-md" style={{color:'var(--white)'}}>{s.title}</h2>
                </div>
                <p className="body-lg" style={{maxWidth:'480px'}}>{s.desc}</p>
              </div>
              <div>
                <p style={{fontSize:'0.7rem',fontWeight:800,letterSpacing:'0.15em',color:'rgba(255,255,255,0.55)',textTransform:'uppercase',marginBottom:'1.25rem'}}>What's included</p>
                <ul className="bullet-list" style={{marginBottom:'2rem'}}>
                  {s.bullets.map(b => <li key={b}>{b}</li>)}
                </ul>
                <Link to="/contact" className="btn btn-gold">Enquire about {s.title.toLowerCase()}</Link>
              </div>
            </div>
          </div>
        ))}
      </section>

      <section className="section section-black2" style={{textAlign:'center',borderTop:'1px solid var(--border)'}}>
        <h2 className="h-xl" style={{color:'var(--white)',marginBottom:'1.25rem'}}>Not sure what<br /><em style={{fontStyle:'normal',color:'var(--gold)'}}>you need?</em></h2>
        <p style={{fontSize:'1rem',color:'rgba(255,255,255,0.70)',fontWeight:300,maxWidth:'460px',margin:'0 auto 2.5rem',lineHeight:1.8}}>Start with a 20-minute discovery call. We'll listen, ask the right questions, and tell you honestly which service fits — or whether you even need us at all.</p>
        <div style={{display:'flex',gap:'1rem',justifyContent:'center',flexWrap:'wrap'}}>
          <Link to="/contact" className="btn btn-gold">Book a discovery call</Link>
          <Link to="/about" className="btn btn-outline">Meet Laura</Link>
        </div>
      </section>
    </>
  );
};

export default Services;
